module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921011149_T.c57f97a1.jpg";